export default __webpack_public_path__ + "static/media/javascript_blog.3d0cc503.jfif";